import { render } from "./Policy.vue?vue&type=template&id=298ed482"
const script = {}

import "./Policy.vue?vue&type=style&index=0&id=298ed482&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__